var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<header class=\"lbModal_header\">\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n<h2>Fare Conditions - {{ vm.carrierName }}</h2>\n</header>\n<div id=\"tabs\">\n<div ng-repeat=\"tab in tabs track by $index\" class=\"tab\" ng-click=\"setActiveTab(tab)\">\n<small>{{ tab.title }}</small>\n</div>\n</div>\n<div id=\"content\">\n<div ng-repeat=\"tab in tabs track by $index\" ng-show=\"tab.active\">\n<h4>{{ tab.title }}</h4>\n<div class=\"detail\" ng-bind-html=\"tab.content\"></div>\n</div>\n</div>\n<style>\n.lbModal_wrapper {\r\n    width: 600px;\r\n    overflow: hidden !important;\r\n    max-height: 79vh !important;\r\n  }\n</style>";
var id1="components/lbFareRulesRailModal/lbFareRulesRailModal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbFareRulesRailModal/lbFareRulesRailModal.html
// module id = 1736
// module chunks = 5